import { http, HttpResponse } from 'msw';

import { apiRoutes } from '@features/campaigns/builder/consts/apiRoutes';

export const campaignCreateRequests = [
  http.post(`*${apiRoutes.createCampaign()}`, ({ request }) => {
    return HttpResponse.json({ ...request.body, id: '123' });
  }),
];
